module.exports = __webpack_public_path__ + "static/profile-9045b4a3f2f2ac84929f680270e0575d.jpg";